import React from "react";

const ExportDefault = (props) => {
  return (
    <button id="scroll-top" title="Back to Top">
      <i className="icon-arrow-up"></i>
    </button>
  );
};

export default ExportDefault;
